import CardBackArt from 'components/CardBackArt';

interface ShufflerDeckCardProps {
  index: 1 | 2 | 3;
}

/** Middle card on top — compact fan for dealer shoe tray */
const FAN = [
  { zIndex: 1, overlap: 0, rotate: -10, lift: 0 },
  { zIndex: 3, overlap: 1, rotate: 0, lift: -1 },
  { zIndex: 2, overlap: 1, rotate: 10, lift: 0 },
] as const;

function ShufflerDeckCard({ index }: ShufflerDeckCardProps) {
  const slot = FAN[index - 1];
  const transform =
    slot.lift !== 0
      ? `translateY(${slot.lift}px) rotate(${slot.rotate}deg)`
      : `rotate(${slot.rotate}deg)`;

  return (
    <span
      className={`tp-shuffler-deck-card tp-shuffler-deck-card-${index}`}
      style={{
        marginLeft: slot.overlap === 0 ? 0 : 'calc(-1 * var(--tp-shoe-fan-overlap, 0.82rem))',
        zIndex: slot.zIndex,
        transform,
      }}
      aria-hidden
    >
      <span className="tp-shuffler-deck-card-face">
        <CardBackArt />
      </span>
    </span>
  );
}

export interface ShufflerShoeProps {
  active?: boolean;
}

/** Premium dealer shoe — fanned deck on the top rail (always shows 3 cards) */
export default function ShufflerShoe({ active = false }: ShufflerShoeProps) {
  return (
    <div className={`tp-shuffler-shoe ${active ? 'tp-shuffler-shoe-active' : ''}`}>
      <div className="tp-shuffler-shoe-rail-cap" aria-hidden />
      <div className="tp-shuffler-shoe-body">
        <div className="tp-shuffler-shoe-rim" aria-hidden />
        <div className="tp-shuffler-shoe-well">
          <div className="tp-shuffler-shoe-deck">
            <ShufflerDeckCard index={1} />
            <ShufflerDeckCard index={2} />
            <ShufflerDeckCard index={3} />
          </div>
        </div>
      </div>
    </div>
  );
}
